import { graphql, useStaticQuery } from 'gatsby'

const SiteMetadata = () => {
  const data = useStaticQuery(
    graphql`
      {
        site: site {
          siteMetadata {
            globalSchema
            maxProductQuantity
            nationwideDeliveryCharge
            phone
            email
            title
          }
        }
      }
    `
  )

  return data.site.siteMetadata
}

export default SiteMetadata
